module.exports = __webpack_public_path__ + "img/vuejs.22efb7c2.svg";